import useResponsive from '@hooks/useResponsive';
import paths from '@constants/paths';
import useCmsComponents from '@hooks/useCmsComponents';
import { extractStoreId } from '@helpers/storeHelper';
import { useParams, usePathname } from 'next/navigation';
import { useMemo } from 'react';

const useCmsStoreContent = (data: HorizontalBannerType) => {
  const params = useParams();
  const pathname = usePathname();
  const { isMobile, isTablet } = useResponsive();
  const isStorePage = useMemo(() => pathname?.startsWith(paths.STORE_PAGE), [pathname]);

  const { data: swrData, isLoading } = useCmsComponents(
    isStorePage ? JSON.stringify(data.uid) : undefined,
    isStorePage ? extractStoreId(params?.storeParameters || '') : undefined
  );

  const horizontalBannerData = isStorePage
    ? swrData?.component?.filter(
        (component): component is HorizontalBannerType => component.typeCode === 'HorizontalBannerComponent'
      )?.[0]
    : data;

  const titleContent = isStorePage
    ? horizontalBannerData?.title
    : isMobile
      ? horizontalBannerData?.titleMobile
      : isTablet
        ? horizontalBannerData?.titleTablet
        : horizontalBannerData?.title;

  const preambleContent = isMobile
    ? horizontalBannerData?.preambleMobile
    : isTablet
      ? horizontalBannerData?.preambleTablet
      : horizontalBannerData?.preamble;

  return {
    titleContent,
    preambleContent,
    isLoading: isStorePage ? isLoading : false,
    horizontalBannerData,
  };
};

export default useCmsStoreContent;
